import InputManageCursor from '../components/input-manage-cursor/InputManageCursor';
import {
  numbersOnly,
  uppercaseLettersNumbers,
} from './normalizers';
import illustration from '../assets/images/gift-voucher-illustration.svg';
import styles from '../components/add-voucher-modal/add-voucher-modal.scss';

export const GIFT_VOUCHER_ILLUSTRATION = {
  extra: true,
  component: 'img',
  name: 'illustration',
  props: {
    src: illustration,
    width: '288',
    height: '155',
    className: styles.voucherIllustration,
  },
};
export const GIFT_VOUCHER_SECURITY_CODE = {
  component: InputManageCursor,
  type: 'text',
  autoComplete: 'off',
  id: 'giftVoucherSecurityCode',
  name: 'securityCode',
  label: 'giftVoucherSecurityCodeLabel',
  placeholder: 'e.g. ABCDEFG',
  a11yText: 'allyDescriptionSecurityCode',
  minLength: 7,
  maxLength: 7,
  required: true,
  validationMessageKeys: {
    required: 'formValidationGiftVoucherSecurityCodeRequired',
    minLength: 'formValidationGiftVoucherSecurityCodeRequired',
    maxLength: 'formValidationGiftVoucherSecurityCodeRequired',
  },
  normalize: uppercaseLettersNumbers,
};

export const GIFT_VOUCHER_SERIAL_NUMBER = {
  component: InputManageCursor,
  type: 'tel',
  autoComplete: 'off',
  id: 'giftVoucherSerialNumber',
  name: 'serialNumber',
  label: 'giftVoucherSerialNumberLabel',
  placeholder: 'e.g. 12 34567890',
  a11yText: 'allyDescriptionSerialNumber',
  minLength: 10,
  maxLength: 10,
  required: true,
  validationMessageKeys: {
    required: 'formValidationGiftVoucherSerialNumberRequired',
    minLength: 'formValidationGiftVoucherSerialNumberRequired',
    maxLength: 'formValidationGiftVoucherSerialNumberRequired',
  },
  normalize: numbersOnly,
};

const addVoucherConfig = () => ({
  id: 'loginForm',
  submitButton: 'formAddVoucherSubmit',
  fields: [GIFT_VOUCHER_ILLUSTRATION, GIFT_VOUCHER_SECURITY_CODE, GIFT_VOUCHER_SERIAL_NUMBER],
});

export default addVoucherConfig;
